// extracted by mini-css-extract-plugin
export default {"header":"Header_header__aT8IF","header_inner":"Header_header_inner__yoGPW","logo":"Header_logo__Ew5nE"};